import React, { useEffect } from "react";
import Field from "../ui/Field";
import { FaMapMarkedAlt, FaRoute } from "react-icons/fa";

export default function TravelFields({
  draft,
  setDraft,
  eventLieu = "",
  onComputeDistance,
  computingDistance = false,
  residenceAddress = "",
}) {
  const show = !!draft?.trajet_necessaire;
  const roundTrip = draft?.aller_retour ?? true;

  useEffect(() => {
    if (!show) return;

    const currentDepart = String(draft?.depart || "").trim();
    const baseResidence = String(residenceAddress || "").trim();

    if (!currentDepart && baseResidence) {
      setDraft((p) => ({
        ...p,
        depart: baseResidence,
      }));
    }
  }, [show, draft?.depart, residenceAddress, setDraft]);

  if (!show) return null;

  return (
    <div className="rounded-2xl ring-1 ring-slate-200 bg-white p-4">
      <div className="flex items-center gap-2 font-semibold text-slate-800">
        <FaMapMarkedAlt className="text-slate-500" />
        Informations trajet
      </div>

      <div className="mt-3 grid gap-4 md:grid-cols-2">
        <Field
          label="Départ (adresse) *"
          value={draft?.depart || ""}
          onChange={(v) => setDraft((p) => ({ ...p, depart: v }))}
          placeholder="Ex : 12 rue des Sports, 33520 Bruges"
        />

        <Field
          label="Arrivée (lieu événement)"
          value={draft?.arrivee ?? eventLieu ?? ""}
          onChange={(v) => setDraft((p) => ({ ...p, arrivee: v }))}
          placeholder="Ex : Dojo de..."
        />

        <Field
          label="Distance Aller (km) *"
          type="number"
          value={draft?.distance_km ?? ""}
          onChange={(v) => setDraft((p) => ({ ...p, distance_km: v }))}
          placeholder="Ex : 120"
        />

        <label className="block">
          <div className="text-sm font-semibold text-slate-700 mb-1">
            Aller / Retour
          </div>
          <button
            type="button"
            onClick={() => setDraft((p) => ({ ...p, aller_retour: !roundTrip }))}
            className={[
              "w-full h-[42px] rounded-xl ring-1 px-3 text-sm transition text-left",
              roundTrip
                ? "bg-emerald-50 text-emerald-800 ring-emerald-200 hover:bg-emerald-100"
                : "bg-slate-50 text-slate-700 ring-slate-200 hover:bg-slate-100",
            ].join(" ")}
          >
            {roundTrip ? "✅ Aller / Retour" : "➡️ Aller simple"}
          </button>
        </label>
      </div>

      <div className="mt-4 flex flex-wrap items-center gap-3">
        <button
          type="button"
          onClick={onComputeDistance}
          disabled={computingDistance}
          className={[
            "h-10 px-4 rounded-xl inline-flex items-center gap-2 transition",
            computingDistance
              ? "bg-slate-200 text-slate-500"
              : "bg-indigo-600 text-white hover:bg-indigo-700",
          ].join(" ")}
        >
          <FaRoute />
          {computingDistance ? "Calcul..." : "Calculer la distance"}
        </button>

        <div className="text-xs text-slate-500">
          Base départ :{" "}
          <strong>{residenceAddress || "adresse profil incomplète"}</strong>
        </div>
      </div>
    </div>
  );
}